import Component from '@glimmer/component';

export default class MwErrorHeader404 extends Component {}
